module.exports = __webpack_public_path__ + "static/media/b.6c601b51.jpg";